L.Icon.Default.imagePath = '/images';

Chart.defaults.global = {
    showTooltips: true,
    tooltipEvents: ["mousemove", "touchstart", "touchmove"],
    tooltipFillColor: "rgba(0,0,0,0.8)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
    tooltipTemplate: "<%=label%>",
    multiTooltipTemplate: "<%= value %>",
    onAnimationProgress: function(){},
    onAnimationComplete: function(){}
}

var EPAT = {
	averages: null,
	product_data: null,
	buyer_map: null,
	markers: [],
	active_marker: null,
	keyIndicators: [1,2,3,4,5],
	sumGroups: {
		forest_cert_total: {
			title: 'Total Certified Fiber',
			percent: true,
			max: 100
		}
	},
	colors: {good: '#1DB472', warning: '#FFC246', alert: '#FF643D', secondary: '#E7E7E7'},
	init: function () {

		var that = this;
		$(document).foundation();

		this.formInit();

		$('.display-login').on('click', $.proxy( that.displayLogin, that));
		//$('.home-jump-to').on('click', $.proxy( that.homeJumpTo, that ));

		$('.wtset_slider').on('change.fndtn.slider', this.handleWeightsetSliderChange);
		$('#set-finalized').on('click', this.setWeightsetFinalized);

		$('#milldata-index-select').on('change',this.lookupMilldata);
		$('body').on('click', '.delete-mill-data', this.deleteMillData);

		$('#mill-products-select').on('change', this.setupProductAssignment);
		$('#update-mill-products').on('click', this.updateProductAssignment);

		$('#permit-business-select').on('change', this.getBuyerPermissions);
		$('#permit-business-products-update').on('click', this.updateBuyerPermissions);

		$('.metric_sub_radio').on('click', this.showCorrectMetricRange);
		if($('.metric_sub_radio').length > 0) {
			this.initCorrectMetricRange();
		}

		$('#buyer-locations-toggle').on('click', $.proxy( that.toggleBuyerMap, that));

		$('body').on('click', '.display-product-mill', $.proxy( that.displayProductMill, that));
		$('#mill-data-modal').on('change', '#toggle-historical-data', function(){
			if($('#toggle-historical-data').prop('checked')) {
				$('#key-performance').addClass('historical');
			} else {
				$('#key-performance').removeClass('historical');
			}
		});

		if($('#buyer-search__results').length > 0) {
			this.initBuyerSearch();
			$('.clear-buyer-search').on('click', $.proxy( that.clearSearchCookie, that));
			$('#toggle-search-filters').on('click', that.toggleAdditionalFilters);
		} else if($('body').hasClass('buyer-supplier-list')) {
			this.initBuyerSupplierSearch();
		}

		$('.meta-slider').on('change.fndtn.slider', that.updateSliderDisplay);

		$('.request-supplier').on('click', $.proxy( that.requestSupplier, that));
		$('.approve-buyer').on('click', $.proxy( that.approveBuyer, that));
		$('.reject-buyer').on('click', $.proxy( that.rejectBuyer, that));

		if($('#product-meta-form').length > 0){
			that.initProductMetaForm();
		}

		$('#delete-user').on('click', $.proxy( that.deleteUser, that));
		$('#submit-user-form').on('click', $.proxy( that.submitUserForm, that));

		// if($('.mill-astor-load').length > 0) {
		// 	that.loadAstorPlots();
		// }

		if($('.mill-meta-slider').length > 0) {
			that.initMillMetaSliders();
		}

		$('#epat-content-section').on('click', '.delete-link', $.proxy( that.handleAjaxDelete, that));
		$('#epat-content-section').on('click','.load-product-year-data',$.proxy( that.productMetaModal, that));
		$('.supplier-product-form').on('click','#submit-product-meta-form',that.productMetaFormSubmit);
		$('.supplier-product-form').on('click','#close-product-meta-form', function(){
			$('#product-year-data').foundation('reveal', 'close');
		});

		$('#mill-data-modal').on('click','.mill-products-more, .mill-description-more',function(e){
			e.preventDefault();
			$(this).closest('.over-limit').toggleClass('show-all');
		});

		$('#toggle-all-auths').on('change', function(){
			$('.checkbox-auth').prop('checked', $(this).prop('checked'));
		});
		if($('#mill-add-authorization').length > 0) {
			that.setupMillAuthSelect2();
		}

		$('.delete-mill-file').on('click', $.proxy( that.handleAjaxDelete, that));

		if($('#mill-file-upload__add').length > 0){ that.handleMillFileAjax(); }

		if($('#milldata-form').length > 0){ that.handleMillDataForm(); }

	},
	setCookie: function(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + "; " + expires;
	},
	getCookie: function(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i = 0; i <ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length,c.length);
	        }
	    }
	    return "";
	},
	displayLogin: function(e){
		e.preventDefault();
		var t = this, element = $(e.currentTarget);
		$('#login-wrapper').slideToggle();
	},
	homeJumpTo: function(e) {
		e.preventDefault();
		var t = this, element = $(e.currentTarget);
		$("html, body").animate({ scrollTop: $(element.attr('href')).offset().top - $('.top-bar-wrapper').outerHeight(true) }, '1000');
	},
	toggleBuyerMap: function(e) {
		e.preventDefault();
		$('body').toggleClass('expanded');
	},
	getPercent: function(value, min, max) {
		if((max - min) != 0)
			return ((value - min) / (max - min)) * 100;
		else
			return 100;
	},
	parseMeta: function(metric) {
		return $.map(metric, function(meta) {
			var avg_per = 100, per = 100;

			if((meta.indicator.max - meta.indicator.min) != 0) {
				avg_per = ((meta.indicator.avg - meta.indicator.min) / (meta.indicator.max - meta.indicator.min)) * 100;
			}
			if(meta.meta_value != null && (meta.indicator.max - meta.indicator.min) != 0) {
				per = ((meta.meta_value - meta.indicator.min) / (meta.indicator.max - meta.indicator.min)) * 100;
			}
			meta.avg 				= meta.indicator.avg != null ? parseFloat(meta.indicator.avg).toFixed(2) : null;
			meta.avgpercent 		= parseFloat(avg_per);
			meta.percent 			= parseFloat(per);
			meta.overavg 			= per > avg_per;
			meta.indicator_percent 	= parseInt(meta.indicator.percent) == 1;
			meta.indicator_sort 	= parseInt(meta.indicator.sort);
			meta.indicator_type 	= parseInt(meta.indicator.meta_type);
			meta.min 				= parseFloat(meta.indicator.min);
			meta.max 				= parseFloat(meta.indicator.max);
			meta.meta_value 		= meta.meta_value != null ? parseFloat(meta.meta_value) : null;
			meta.reported 			= parseInt(meta.reported) == 1;
			meta.verified 			= parseInt(meta.verified) == 1;
			meta.na 				= parseInt(meta.na) == 1;
			meta.year 				= parseInt(meta.year);
			meta.rank_desc 			= parseInt(meta.indicator.rank_desc);
			return meta;
		});
	},
	initBuyerSearch: function(){
		var t = this;
		if($('#buyer-locations').length > 0){
			t.sizeBuyerMap();
			$(window).resize(t.sizeBuyerMap);
		}

		var init_zoom = 4;
		if($(window).width() < 1200) {
			init_zoom = 3;
		}

		if($('#buyer-locations').length > 0){
			t.buyer_map = this.createMap('buyer-locations',39.4453135,-96.0191536,init_zoom), latLngBounds = [];
		}

		t.buyerSearchByYear();
		$('#buyer-filter-mill-year').on('change',function(){
			t.buyerSearchByYear();
		});

		if(t.buyer_map != null){
			t.buyer_map.on('moveend', function(e) {
				$.each(t.markers,function(index, marker) {
					var latLng = marker.getLatLng();
					if(t.active_marker != marker || !t.inBounds(latLng.lat,latLng.lng)){
						t.buyer_map.removeLayer(marker);
					}
				});
			    t.searchBuyerResults();
			});
		}

		$('.buyer-search-filter').on('keyup change paste', function(){
			if($(this).attr('id') == 'buyer-filter-mill-type') {
				t.updateSliderRanges();
			}
			t.clearMarkers();
			t.searchBuyerResults();
		});
	},
	buyerSearchByYear: function() {
		var t = this;
		$('#buyer-search').append('<div id="search-loading-overlay"></div>');
		$.get('/buyer.json?year=' + $('#buyer-filter-mill-year').val(), function(response){
			t.keyIndicators = response.indicators;
			var keys = $.map(t.keyIndicators, function(k){ return k.id; });

			t.product_data = $.map( response.mills , function( m ) {
				m.id 		= parseInt(m.id);
				m.business_url = m.business.url;
				m.business = m.business.name;
				m.mill_type = parseInt(m.mill_type);
				m.meta = t.parseMeta(m.meta);
				m.year = m.meta.length > 0 ? m.meta[0].year : null;
				m.meta = _.sortBy(m.meta,'indicator_sort');
				m.meta = $.map(m.meta, function(meta) {
					meta.mill_type = m.mill_type;
					return meta;
				});
				m.key_metrics = _.filter(m.meta, function(meta){ return keys.indexOf(meta.indicator_id) !== -1; });

				m.product_types = $.map( m.products, function(p) {
					return parseInt(p.product_type);
				});
				m.product_categories = $.map( m.products, function(p) {
					return parseInt(p.category);
				});
				return m;
			});

			if($('#buyer-search__fields').length > 0){
				t.setupBuyerFilters();
			}
			t.setupBuyerResults();

			$('#search-loading-overlay').fadeOut('slow',function(){
				$(this).remove();
			});
		});
	},
	initBuyerSupplierSearch: function(){
		var t = this, marker_template = Handlebars.compile($('#mill-marker-template').html());;
		t.sizeBuyerSupplierMap();
		$(window).resize(t.sizeBuyerSupplierMap);

		var init_zoom = 4;
		if($(window).width() < 1200) {
			init_zoom = 3;
		}
		t.buyer_map = this.createMap('buyer-supplier-locations',39.4453135,-96.0191536,init_zoom), latLngBounds = [];

		$.each(all_mills, function(index, mill) {
			if(mill.lat != null && mill.lng != null){
				t.createMapMarker(t.buyer_map, mill.lat, mill.lng, marker_template(mill), false);
			}
		});

		$('#send-supplier-request').on('click', t.requestSupplierSubmit);
		$('.close-request-modal').on('click',function(e){
			e.preventDefault();
			$('#request-access-modal').foundation('reveal','close');
		});
		$('.request-business').on('click', function(e){
			e.preventDefault();
			var business = $(this).closest('.buyer-supplier-search__item').find('.supplier-business-information h4.business-name').text();
			$('#request-access-modal span.business-name-span').text(business);
			$('#mill-request-fields').html('');
			$('#mill-request-message').val('');
			$(this).closest('.supplier-mill-information').find('.request-supplier').each(function(){
				var el = $(this),
					mill_id = el.data('mill'),
					name = $('#supplier-mill-' + mill_id).find('.mill__name').text(),
					location = $('#supplier-mill-' + mill_id).find('.mill__location').text();
				$('#mill-request-fields').append('<li data-mill="'+mill_id+'">'+name+'</li>');
			});
			$('#request-access-modal').foundation('reveal', 'open');
		});

		$('#mill-search-text').on('keyup change paste', function(){
			var terms = $('#mill-search-text').val().trim();
			if(terms == '') {
				$('.buyer-supplier-search__item, .supplier-mill-info, .request-business').removeClass('hidden').show();
			} else {
				$('.request-business').hide();
				terms = terms.split(' ');
				$('.buyer-supplier-search__item').each(function(){
					var has_term = false, business = $(this);
					business.hide();
					business.find('.supplier-mill-info').each(function(){
						var sup_mill = $(this),
							mill_has_term = false,
							mill_name = sup_mill.find('.mill__name').text().toLowerCase();
						sup_mill.addClass('hidden').hide();
						$.each(terms, function(index, term) {
							if(mill_name.indexOf(term.toLowerCase()) !== -1) {
								sup_mill.removeClass('hidden').show();
								business.show();
							}
						});
					});
				});
			}
		});
	},
	formInit: function() {
		$('input[type="text"], textarea, input[type="email"], input[type="password"]').each(function(){
			var that = $(this), pl = that.attr('placeholder'), cl = that.data('class');
			if(!that.hasClass('disable-styling')){
				that.wrap('<div class="search-filter__wrapper text '+(cl != undefined ? cl : '')+'"></div>');
				that.before('<span class="search-filter__label">'+pl+'</span><span class="search-filter__value"></span>');
				if(that.val() != '') {
					$(this).closest('.search-filter__wrapper')
						.addClass('active');
				}
				that.on('keyup change paste',function() {
					if($(this).val() == '') {
						$(this).closest('.search-filter__wrapper')
							.removeClass('active');
					} else {
						$(this).closest('.search-filter__wrapper')
							.addClass('active');
					}
				});
			}
		});
		$('select.epat-select').each(function(){
			var that = $(this), pl = that.data('placeholder'), cl = that.data('class');
			that.wrap('<div class="search-filter__wrapper select '+(cl != undefined ? cl : '')+'"></div>');
			that.before('<span class="search-filter__label">'+pl+'</span><span class="search-filter__value select">'+pl+'</span>');
			if(that.val() != '') {
				$(this).closest('.search-filter__wrapper')
					.addClass('active')
					.find('.search-filter__value')
					.text(that.find('option:selected').text());
			}
			that.on('keyup change paste',function() {
				if($(this).val() == '') {
					$(this).closest('.search-filter__wrapper')
						.removeClass('active')
						.find('.search-filter__value')
						.text(pl);
				} else {
					$(this).closest('.search-filter__wrapper')
						.addClass('active')
						.find('.search-filter__value')
						.text(that.find('option:selected').text());
				}
			});
		});
		autosize($('textarea'));
	},
	clearMarkers: function(){
		var t = this;
		if(t.buyer_map != null){
			$.each(t.markers,function(index, marker) {
				t.buyer_map.removeLayer(marker);
			});
		}
	},
	setupBuyerFilters: function() {
		var t = this, metrics_template = Handlebars.compile($('#performance-metric-template').html());

		// metrics = _.filter(t.averages,function(m){
	 //      	return t.keyIndicators.indexOf( parseInt(m.indicator_id) ) !== -1;
	 //    });

	 	// console.log(t.keyIndicators);
		$('#key-performance-filters').html( metrics_template({metrics: t.keyIndicators}) );
		// $('#additional-performance-filters').html( metrics_template({metrics: additional_metrics}) );

		$('.filter-slider-range').each(function(){
			var s = $(this), indicator = s.data('indicator'),
				steps = (s.data('max') - s.data('min')) / 100;

			s.slider({
				range: true,
				// min: s.data('min'),
				// max: s.data('max'),
				// step: steps,
				// values: [ s.data('min'), s.data('max') ],
				min: 0,
				max: 100,
				step: 1,
				values: [ 0, 100 ],
				create: function( event, ui ) {
					s.find('.ui-slider-handle').eq(0).html('<span class="handle-value handle-value-min"></span>');
					s.find('.ui-slider-handle').eq(1).html('<span class="handle-value handle-value-max"></span>');
				},
				slide: function( event, ui ) {
					s.find('.handle-value-min').text(ui.values[ 0 ].toFixed(2));
					s.find('.handle-value-max').text(ui.values[ 1 ].toFixed(2));
					t.clearMarkers();
					t.searchBuyerResults();
				},
				stop: function( event, ui ) {
					s.find('.handle-value-min').text(ui.values[ 0 ].toFixed(2));
					s.find('.handle-value-max').text(ui.values[ 1 ].toFixed(2));
					t.clearMarkers();
					t.searchBuyerResults();
				}
			});
		});

		t.updateSliderRanges();
	},
	updateSliderRanges: function() {
		var t = this;
		var keys = $.map(t.keyIndicators, function(k){ return k.id });
		var mills = _.filter(t.product_data,function(d){ return d.mill_type == $('#buyer-filter-mill-type').val()});
		$('.metric-filter').hide().find('.filter-slider-range').addClass('inactive');
		$.each(mills,function(i,mill) {
			var meta = _.filter(mill.meta,function(meta){ return keys.indexOf(meta.indicator_id) !== -1 });
			$.each(meta,function(i,m){
				if(m.min != m.max) {
					$('#metric-filter-' + m.indicator_id).show();
					$('#metric-filter-' + m.indicator_id+ ' .filter-slider-range')
						.data('min',Math.floor(parseFloat(m.min)))
						.data('max',Math.ceil(parseFloat(m.max)))
						.data('indicator',m.indicator_id)
						.slider('option','min',Math.floor(parseFloat(m.min)))
						.slider('option','max',Math.ceil(parseFloat(m.max)))
						.slider('option','step',((parseFloat(m.max) - parseFloat(m.min)) / 10000))
						.slider( "values", [Math.floor(parseFloat(m.min)), Math.ceil(parseFloat(m.max))])
						.removeClass('inactive');
					$('#metric-filter-' + m.indicator_id).find('.filter-slider-average').css('left',m.avgpercent + '%')
						.find('span').text(parseFloat(m.indicator.avg).toFixed(2));
					$('#metric-filter-' + m.indicator_id).find('span.handle-value-min').text(parseFloat(m.min).toFixed(2));
					$('#metric-filter-' + m.indicator_id).find('span.handle-value-max').text(parseFloat(m.max).toFixed(2));
					var ind_ind = keys.indexOf(m.indicator_id);
					keys = keys.splice(ind_ind,1);
				}
			});
		});
		t.setupBuyerResults();
	},
	setupBuyerResults: function() {
		var t = this;
		t.searchBuyerResults();
		if($('#buyer-locations').length > 0) {
			var bounds = t.setupMapAndProducts(t.product_data);
			if(bounds.length > 0){
				t.buyer_map.fitBounds(bounds);
			}
		}
	},
	setupMapAndProducts: function(m) {
		var t = this,
			results_template = Handlebars.compile($("#buyer-result").html()),
			marker_template = null,
			mills = [],
			bounds = [];

		var m_ids = $.map(m, function(tmp){ return tmp.id; });
		var all_mills = _.filter(t.product_data, function(m){
			return m.mill_type == $('#buyer-filter-mill-type').val();
			// return m.mill_type == $('#buyer-filter-mill-type').val() && m.mill_type == ($('#buyer-filter-type').prop('checked') ? 1 : 2)
		});

		m = $.map(all_mills, function(m){
			m.matches = m_ids.indexOf(m.id) !== -1;
			return m;
		});

		if($('#mill-marker-template').length > 0){
			marker_template = Handlebars.compile($('#mill-marker-template').html());
		}

		if(m.length > 0){
			$.each(m, function(index, mill) {
				if(t.buyer_map != null){
					t.createMapMarker(t.buyer_map, mill.lat, mill.lng, marker_template(mill), false);
					bounds.push([mill.lat, mill.lng]);
				}
				mills.push(mill.id);
			});
		}

		m = _.sortBy(m, function(tmp){ return (tmp.matches ? 'A_' : 'Z_') + tmp.name; });
		$('#buyer-search__results').html(results_template({mills: m}));
		$('#buyer-search__results li.product-mill-' + $('.leaflet-popup-pane .mill-marker').data('mill')).addClass('active-mill');
		$('#buyer-search__container .results-quick-stats li.quick-metric').css('width', ((100 / t.keyIndicators.length) - 4) + '%');
		return bounds;
	},
	getSearchCookie: function(cname) {
		var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0; i<ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1);
	        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
	    }
	    return "";
	},
	setSearchCookie: function(name, data, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
    	var expires = "expires="+d.toUTCString();
    	document.cookie = name + "=" + data + "; " + expires;
	},
	clearSearchCookie: function(e) {
		var t = this;
		e.preventDefault();
		$('.filter-slider-range').each(function(){
			$(this).slider('values',[$(this).data('min'),$(this).data('max')]);
		});
		$('#buyer-filter-type').prop('checked',true);
		$('#buyer-search__fields select, #mill-search-text').not('#buyer-filter-mill-type, #buyer-filter-mill-year').val('');
		t.checkFancySelects();
		t.setSearchCookie('epat_search','',0);
		t.searchBuyerResults();
	},
	checkFancySelects: function() {
		if($('#buyer-filter-type').length > 0 && !$('#buyer-filter-type').prop('checked')) {
			$('#buyer-filter-category').closest('.search-filter__wrapper').hide();
			$('#buyer-filter-pulp-category').closest('.search-filter__wrapper').show();
		} else {
			$('#buyer-filter-category').closest('.search-filter__wrapper').show();
			$('#buyer-filter-pulp-category').closest('.search-filter__wrapper').hide();
		}

		$('.search-filter__wrapper').each(function(){
			if($(this).find('select').val() == '') {
				$(this).closest('.search-filter__wrapper').removeClass('active');
			} else {
				$(this).closest('.search-filter__wrapper').addClass('active');
			}
		});
	},
	searchBuyerResults: function() {
		var t = this, mills = t.getResultsByFilter();
		t.checkFancySelects();
		mills = _.sortBy(mills, 'name');
	    return t.setupMapAndProducts(mills);
	},
	getResultsByFilter:function(){
		var t = this,
			mills = t.product_data,
			center = t.buyer_map != null ? t.buyer_map.getCenter() : null,
			bounds = t.buyer_map != null ? t.buyer_map.getBounds() : null;

		//FILTER BY BOUNDS
		if(t.buyer_map != null && !$('body').hasClass('expanded')){
			mills = _.filter(mills,function(m){
		      	return ($(window).width() <= 640 || t.inBounds(m.lat, m.lng));
		    });
		}

	    //PRODUCT FILTERS
		return _.filter(mills,function(m){
			if($('#buyer-search__fields').length == 0) { return true; }

			if($('#buyer-filter-mill-type').val() != '' && m.mill_type != parseInt($('#buyer-filter-mill-type').val())){
				return false;
			}

			var has_type = false,
				product_type = 1,
				product_category = '#buyer-filter-category',
				search_text = $('#mill-search-text').val();

			if($('#buyer-filter-type').length > 0 && !$('#buyer-filter-type').prop('checked')) {
				product_type = 2;
				product_category = '#buyer-filter-pulp-category';
			}

			// if(m.product_types.indexOf(product_type) === -1) {
			// 	return false;
			// }
			if($(product_category).val() != '' && m.product_categories.indexOf(parseInt($(product_category).val())) === -1) {
				return false;
			}

			var has_search = false;
			if(search_text != '') {
				search_text = search_text.toLowerCase().split(' ');
				mill_name = m.name.toLowerCase();
				biz_name = m.business.toLowerCase();
				$.each(search_text,function(index2, term) {
					if(mill_name.indexOf(term) !== -1) {
						has_search = true;
					}
				});
				if(!has_search){
					$.each(search_text,function(index2, term) {
						if(biz_name.indexOf(term) !== -1) {
							has_search = true;
						}
					});
				}
				if(!has_search){
					return false;
				}
			}

			//CHECK INDICATORS
			var filters = true;
			$('.filter-slider-range').not('.inactive').each(function() {
				var s = $(this),
					indicator = s.data('indicator'),
					values = s.slider( "values" );

				var tmp = _.findWhere(m.meta, {indicator_id: indicator});
				if(tmp != null && parseFloat(tmp.meta_value) >= values[0] && parseFloat(tmp.meta_value) <= values[1]) {
					// NOTHING
				} else {
					filters = false;
				}
			});
			return filters;
		});
	},
	inBounds: function(lat,lng) {
		var t = this, bounds = t.buyer_map.getBounds();
		return bounds._southWest.lat <= lat && bounds._southWest.lng <= lng && bounds._northEast.lat >= lat && bounds._northEast.lng >= lng;
	},
	convertKGtoLB: function(w) {
		return w * 2.20462;
	},
	sizeBuyerMap: function() {
		var margin = $('.top-bar').outerHeight();
		$('#buyer-locations, #buyer-search').css('height', $(window).height() - margin).css('top', margin);
	},
	sizeBuyerSupplierMap: function(){
		var margin = $('.top-bar').outerHeight();
		$('#buyer-supplier-locations, #buyer-supplier-search').css('height', $(window).height() - margin).css('top', margin);
	},
	createMap: function(elementid,lat,lng,zoom) {
		var map = L.map(elementid,{ scrollWheelZoom: false }).setView([lat, lng], zoom);
		L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
			attribution: '&copy; EPAT',
			maxZoom: 18,
		}).addTo(map);
		// L.tileLayer.provider('HERE.normalDayTransit').addTo(map);
		return map;
	},
	createMapMarker: function(map,lat,lng,content,openByDefault){
		var t = this;
		var marker = L.marker([lat, lng]).addTo(map).bindPopup(content);
		if(openByDefault){ marker.openPopup(); }
		marker.on('popupopen', function(e){
			t.active_marker = marker;
			$('#buyer-search__results li.product-mill-' + $('.leaflet-popup-pane .mill-marker').data('mill')).addClass('active-mill');
		}).on('popupclose', function(e){
			t.active_marker = null;
			$('#buyer-search__results li').removeClass('active-mill');
		});
		t.markers.push(marker);
	},
	displayProductMill: function(e){
		e.preventDefault();

		var t = this, element = $(e.currentTarget), mill_id = element.data('mill');
		var year = element.data('year');

		t.loadMillDataByYear(mill_id, year);
	},
	loadMillDataByYear: function(mill_id, year){
		var t = this;

		$('#mill-data-modal-loading').fadeIn();

		var prev_mill = null;
		var next_mill = null;
		var current_mill = $('#buyer-search__results').find('.product-mill-' + mill_id).index();

		if(current_mill !== -1){
			prev_mill = current_mill - 1;
			next_mill = current_mill + 1;
			if(prev_mill < 0) {
				prev_mill = $('#buyer-search__results .mill-result').length - 1;
			}
			if(next_mill >= $('#buyer-search__results .mill-result').length) {
				next_mill = 0;
			}
		}

		$.get('/json/mill/'+mill_id+'.json?year=' + year ,function(data){
			var template = Handlebars.compile($("#mill-single-template").html());

			if($('#buyer-search__results').length > 0){
				data.previousmill = $('#buyer-search__results .mill-result').eq(prev_mill).data('mill');
				data.nextmill = $('#buyer-search__results .mill-result').eq(next_mill).data('mill');
				data.previousmill_year = $('#buyer-search__results .mill-result').eq(prev_mill).data('year');
				data.nextmill_year = $('#buyer-search__results .mill-result').eq(next_mill).data('year');
			}

			data.indicators = $.map(data.indicators,function(i){
				i.rank_desc = parseInt(i.rank_desc);
				i.percent = parseInt(i.percent);

				i.averages = _.find(data.averages, function(a) { return parseInt(a.id) === parseInt(i.id); });
				if(i.averages.avg !== null) {
					i.averages.avg = parseFloat(i.averages.avg).toFixed(2);
					// i.averages.min = parseFloat(i.averages.min);
					i.averages.min = 0;
					i.averages.max = parseFloat(i.averages.max);
					if(i.averages.avg == 0) {
						i.averages.avgpercent = 0;
					} else {
						i.averages.avgpercent = t.getPercent(i.averages.avg, i.averages.min, i.averages.max);
					}
				} else {
					i.averages.avg = 'N/A';
					i.averages.avgpercent = 50;
				}

				i.has_definition = _.isEmpty(i.definition) ? false : true;
				if(parseInt(i.min_value) === 0 && parseInt(i.max_value) === 1) {
					i.is_boolean = true;
				}

				i.meta = _.filter(data.meta, function(m){ return parseInt(m.indicator_id) === parseInt(i.id); });
				i.meta = $.map(i.meta, function(m){
					m.na = parseInt(m.na);
					m.reported = parseInt(m.reported);
					m.verified = parseInt(m.verified);
					m.meta_value = parseFloat(m.meta_value);
					m.percent = m.na ? 0 : t.getPercent(m.meta_value, i.averages.min, i.averages.max);

					if(i.meta_type == 2) {

						m.display_meta_value = m.meta_value + ' of ' + i.max_value;

					} else if( !parseInt(m.na) && m.meta_value !== null) {
						if(parseInt(i.min_value) === 0 && parseInt(i.max_value) === 1) {
							m.display_meta_value = parseInt(m.meta_value) === 1 ? '<span class="cert_num_header">' + i.range + ':</span><span class="cert_num">' + m.metric + '</span>' : 'No';
							m.metric = null;
						} else {
							m.display_meta_value = m.meta_value + (i.percent ? '%' : '');
						}
					} else if(parseInt(m.na) || m.meta_value === null) {
						m.display_meta_value = 'N/A';
						m.percent = 0;
					}

					if(parseInt(m.meta_value) == 0) {
						m.percent = 0;
					}

					m.mill = _.findWhere(data.permitted, { id: m.mill_id });
					m.width = (1 / i.meta.length) * 100;
					m.this_mill = m.mill_id == data.mill.id ? true : false;
					return m;
				});

				i.meta = _.sortBy(i.meta, function(m){ return m.percent; });

				i.thisMeta = i.meta.filter(function(m) {
					return m.mill_id === mill_id;
				});

				i.displayValue = _.findWhere(i.meta, { indicator_id: i.id, mill_id: data.mill.id });

				i.historical = _.filter(data.historical, function(h){ return parseInt(h.indicator_id) === parseInt(i.id) });
				i.historical = _.sortBy(i.historical, function(h){ return h.year; });
				i.historical = $.map(i.historical, function(h){
					h.width = (1 / i.historical.length) * 100;
					h.meta_value = parseFloat(h.meta_value);

					if(i.meta_type == 2) {
						h.display_meta_value = h.meta_value + ' of ' + i.max_value;
					} else if( !parseInt(h.na) && h.meta_value !== null) {
						h.display_meta_value = h.meta_value + (i.percent ? '%' : '');
					} else if(parseInt(h.na) || h.meta_value === null) {
						h.display_meta_value = 'N/A';
					}

					h.percent = parseInt(h.na) ? 0 : t.getPercent(h.meta_value, i.averages.min, i.averages.max);
					return h;
				});

				var i_template = Handlebars.compile($("#mill-single-template__type0").html());
				i.html = i_template(i);

				return i;
			});

			if(report_indicators !== undefined && report_indicators.length > 0){
				report_indicators = _.map(report_indicators, function(i){ return parseInt(i); });
				data.indicators = _.filter(data.indicators, function(i){
					return _.indexOf(report_indicators, parseInt(i.id)) !== -1;
				});
			}

			data.categories = $.map(data.categories,function(c){
				c.id = parseInt(c.id);
				c.parent = parseInt(c.parent);
				c.sort = parseInt(c.sort);
				c.indicators = _.filter(data.indicators, function(i) { return parseInt(i.category) === parseInt(c.id); });
				c.indicators = _.sortBy(c.indicators, function(i) { return i.sort; });
				c.showing = t.getCookie('indicator' + c.id);
				return c;
			});

			// data.categories = _.filter(data.categories, function(c){
			// 	return c.indicators.length > 0;
			// });

			data.output = _.filter(data.categories, {parent: 0});
			data.output = $.map(data.output, function(d){
				d.children = _.filter(data.categories, function(c){ return c.parent == d.id && c.indicators.length > 0;});
				d.children = _.sortBy(d.children, function(i){ return parseInt(i.sort); });
				return d;
			});

			data.output = _.filter(data.output, function(d){
				return d.children.length !== 0 || d.indicators.length !== 0;
			});

			var product_type_string = [];
			$.each(data.mill.products, function(index, p) {
				data.mill.products[index].product_type = data.product_types[p.category];
				if(product_type_string.indexOf(data.product_types[p.category]) === -1){
					product_type_string.push(data.product_types[p.category]);
				}
			});
			data.product_type_string = product_type_string.join(', ');

			$('#mill-data-modal').html(template(data));
			if(!$('#mill-data-modal').hasClass('open')){
				$('#mill-data-modal').foundation('reveal', 'open');
			}

			$('#mill-data-modal-loading').fadeOut();
			// $('#mill-data-modal').html(template(data)).foundation('reveal', 'open');
			setTimeout(function(){
	    		t.setupMillCharts(data);

 	   			if($('#mill-products').height() > 400) {
 	   				$('#mill-products').addClass('over-limit');
 	   			}
 	   			if($('.mill-description-container').height() > 200) {
 	   				$('.mill-description-container').addClass('over-limit');
 	   			}
	    	},500);

	    	$('.kpi-definition-reveal').on('click',function(e){
	    		e.preventDefault();
	    		$('#'+$(this).data('definition')).css('max-height',($(window).height() - 50)).fadeIn();
	    		$('.kpi-definition-bg').fadeIn();
	    	});
	    	$('.close-definition, .kpi-definition-bg').on('click',function(e){
	    		e.preventDefault();
	    		$('.kpi-definition-bg, .kpi-definition').fadeOut();
	    	});

	    	$('html,body').animate({scrollTop: 0});

			$('.toggle-indicator-view').on('click', function(e){
				e.preventDefault();
				var el = $(this);

				el.closest('.indicators-wrapper').toggleClass('showing');
				t.setCookie('indicator' + el.data('indicator'), el.closest('.indicators-wrapper').hasClass('showing') ? 'showing' : '', 90);
			});

			var years = _.map(data.historical, function(m){ return m.year });
			years.sort();
			years = _.uniq(years);


			if(years.length > 1){
				$('#load-new-mill-year').html('');
				$.map(years, function(y){
					$('#load-new-mill-year').append('<option value="'+y+'" '+(year == y ? 'selected="selected"' : '')+'>'+y+'</option>');
				});
				$('#load-new-mill-year').on('change',function(){
					t.loadMillDataByYear(mill_id, $(this).val());
				});
			}

			var sumGroups = _.map($('#key-performance .key-performance-row'), function(i){ return $(i).data('sum-group'); });
			sumGroups = _.uniq(_.filter(sumGroups, function(g){ return g !== undefined; }));

			_.map(sumGroups, function(g){

				var group_ind = _.filter(data.indicators, function(i){ return i.sum_group === g; });

				var ind_meta = _.map(group_ind, function(i){
					var mill_data = _.filter(i.meta,function(m){ return m.this_mill; });
					if(mill_data.length > 0)
						return mill_data[0];
					else
						return null;
				});
				ind_meta = _.filter(ind_meta,function(m){ return m !== null && m.na === 0; });

				var groupTotal = 'N/A';
				if(ind_meta.length > 0){
					ind_meta = _.map(ind_meta, function(m){ return m.meta_value });
					groupTotal = ind_meta.reduce(function add(a, b) { return a + b; }, 0);
				}

				var group_output = '<div class="key-performance-row sum-group-total"><div class="sum-group-total-wrapper">'+
					'<div class="inidicator-name kp-col"><strong>'+ t.sumGroups[g].title + '</strong></div>'+
					'<div class="inidicator-value kp-col"><span class="label secondary">' + groupTotal + (t.sumGroups[g].percent ? '%' : '') + '</span></div>' +
					'</div></div>';

				$('#key-performance .key-performance-row[data-sum-group="'+g+'"]').first().before(group_output);
				$('#key-performance .key-performance-row[data-sum-group="'+g+'"]').last().after('<hr />');
			});


	    	// t.setupHistoricalData(mill_id,data.year);
		});
	},

	setupHistoricalData: function(mill_id, viewing_year) {
		var t = this;

		$.get('/mill/historical/'+mill_id+'.json' ,function(data){
			var years = [];
			var template = Handlebars.compile($("#historical-result").html());
			$.each(data,function(i,indicator){

				var total = 0;
				indicator.historical = $.map(indicator.historical, function(value, index) {
					years.push(index);
					total += value.value;
					return {
						name: indicator.name,
						year: index,
						this_year: (index == viewing_year),
						percent: 0,
						value: value.value,
						human_value: value.value + (indicator.percent ? '% ' : ' ') + indicator.metric
					};
				});

				if($('#inidicator-historical-' + i).length > 0 && indicator.historical.length > 1) {
					var max = _.max(indicator.historical, function(h){ return h.value; });
					var min = _.min(indicator.historical, function(h){ return h.value; });

					indicator.historical = $.map(indicator.historical, function(value, index) {
						value.percent = (value.value / max.value * 100);
						value.width   = Math.floor(100 / indicator.historical.length)
						return value;
					});

					indicator.avg 			= (total / indicator.historical.length).toFixed(2);
					indicator.avgpercent 	= (indicator.avg / max.value * 100);

					$('#inidicator-historical-' + i).html(template(indicator));
				} else {
					$('#inidicator-historical-' + i).html('<p>No historical ' +indicator.name+ ' data</p>');
				}
			});

			years.sort();
			years = _.uniq(years);

			if(years.length > 1){
				$('#load-new-mill-year').html('');
				$.map(years, function(y){
					$('#load-new-mill-year').append('<option value="'+y+'" '+(viewing_year == y ? 'selected="selected"' : '')+'>'+y+'</option>');
				});
				$('#load-new-mill-year').on('change',function(){
					t.loadMillDataByYear(mill_id, $(this).val());
				});
			}

		});
	},
	getRank: function(indicator_id, mill_id) {
		var t = this, mills = t.getResultsByFilter(), rank_direction = false;
		var mill = _.findWhere(t.product_data, { id: mill_id });
		mills = _.filter(mills, function(m){ return m.mill_type == mill.mill_type });
		mills = $.map(mills,function(m){
			var metric = _.findWhere(m.meta, { indicator_id: indicator_id });
			if(metric != null)
				rank_direction = metric.rank_desc;
			return {
				mill: m.id,
				value: metric == null ? 'N/A' : metric.meta_value
			};
		});
		mills = _.filter(mills, function(m){ return m.value != 'N/A' });
		mills = _.sortBy(mills, function(m){ return m.value; });
		if(rank_direction) {
			mills.reverse();
		}
		var rank = _.findIndex(mills, {mill: mill_id});
		return {rank: (rank !== -1 ? rank + 1 : null), total: mills.length};
	},
	millAstorPlot: function(id, metrics, year){
		t = this;
		var order = 0;

		// metrics = _.filter(metrics, function(m){ return m.meta_type == 0 && m.value != 'N/A'; });

		if(metrics.length == 0){
			$(id).html('<span class="no-data">No Data Available</span>');
			return;
		}

		var width = $(id).width(),
		    height = width,
		    radius = Math.min(width, height) / 2,
		    innerRadius = 0.5 * radius;

		var pie = d3.layout.pie()
		    .sort(null)
		    .value(function(d) { return d.width; });

		var tip = d3.tip()
		  .attr('class', 'd3-tip')
		  .offset([0, 0])
		  .html(function(d) {
		    return d.data.label;
		  });

		var arc = d3.svg.arc()
		  .innerRadius(innerRadius)
		  .outerRadius(function (d) {
		    return (radius - innerRadius) * (d.data.score / 100.0) + innerRadius;
		  });

		var inlineArc = d3.svg.arc()
		        .outerRadius(radius);

		var outlineArc = d3.svg.arc()
		        .innerRadius(innerRadius)
		        .outerRadius(radius);

		var svg = d3.select(id).append("svg")
				    .attr("width", width)
				    .attr("height", height)
				    .append("g")
				    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

		svg.call(tip);

		var innerPath = svg.selectAll(".inlineArc")
					.data(pie(metrics))
					.enter().append("path")
					.attr("fill", "#ffffff")
					.attr("stroke", "#ffffff")
					.attr("class", "inlineArc")
					.attr("d", inlineArc);

		var path = svg.selectAll(".solidArc")
					.data(pie(metrics))
					.enter().append("path")
					.attr("fill", function(d) { return d.data.color; })
					.attr("class", "solidArc")
					.attr("stroke", "#ffffff")
					.attr("d", arc)
					.on('mouseover', tip.show)
					.on('mouseout', tip.hide);

		var outerPath = svg.selectAll(".outlineArc")
					.data(pie(metrics))
					.enter().append("path")
					.attr("fill", "none")
					.attr("stroke", "#ffffff")
					.attr("class", "outlineArc")
					.attr("d", outlineArc);

		var score = metrics.reduce(function(a, b) { return a + (b.score * b.weight); }, 0) / metrics.reduce(function(a, b) { return a + b.weight; }, 0);

		svg.append("svg:text")
					.attr("class", "aster-title")
					.attr("dy", "-1.35em")
					.attr("text-anchor", "middle")
					.text('Data From');

		svg.append("svg:text")
					.attr("class", "aster-score")
					.attr("dy", ".5em")
					.attr("text-anchor", "middle")
					.text(year);

		$('#mill-astor-plot').css('opacity',1);
	},
	loadAstorPlots: function(){
		var t = this;
		// astor = $.map(astor,function(a){
		// 	a.mill_id = parseInt(a.mill_id);
		// 	a.mill_type = parseInt(a.mill_type);
		// 	if(a.meta != null){
		// 		a.meta = t.parseMeta(a.meta);
		// 	} else {
		// 		a.meta = [];
		// 	}
		// 	return a;
		// });

		$('.mill-astor-load').each(function(){
			var that = $(this),
				mill_id = that.data('mill');
			$.get('/supplier/mill/' + mill_id, function(rsp){
				var astor = [], order = 0, year = null;
				if(rsp.meta_latest != null){
					var meta = _.filter(rsp.meta_latest, function(m){ return m.meta_value != null });
					$.each(meta,function(index,value){
						order++;
						value.position = parseInt(value.rank_desc) ? (value.total - value.position + 1) : value.position;
						value.meta_value = parseFloat(value.meta_value);
						value.avg = parseFloat(value.avg);
						year = value.year;
						astor.push({
							id: order,
							order: order,
							score: 100,
							weight: 1,
							width: 1,
							above_avg: (value.position / value.total > 0.25) ? true : false,
							color: (value.position / value.total > 0.25) ? t.colors.secondary : t.colors.good,
							value: value.meta_value,
							label: value.name + ': ' + value.meta_value.toFixed(2) + (parseInt(value.percent) ? '%' : '') + '<span>'+value.metric+'</span><span>(Avg: ' + value.avg.toFixed(2) + ')</span>'
						});
					});
					astor = _.sortBy(astor,'above_avg');
				}
				t.millAstorPlot("div#mill-astor-" + mill_id, astor, year);
			});
		});
	},
	setupMillCharts: function(data) {
		t = this;

		var pieChartColors = [], heights = [];
		pieChartColors[0] = {normal: '#F6F6F6', hightlight: '#F6F6F6'};
		pieChartColors[1] = {normal: '#0077A4', hightlight: '#84C6DF'};
		pieChartColors[2] = {normal: '#008EBE', hightlight: '#abcdef'};
		pieChartColors[3] = {normal: '#02A7D7', hightlight: '#90D2EB'};
		pieChartColors[4] = {normal: '#35C1F1', hightlight: '#9FDFF8'};
		pieChartColors[5] = {normal: '#5AD5FF', hightlight: '#AEE9FF'};

		$.each(data.mill.products, function(index, product) {
			var c = $('#product-chart-' + product.id), other = 100;
			c.css('width', c.closest('.canvas-container').width()).css('height', c.closest('.canvas-container').width());

			var single = c.closest('.mill-products__single');
			var meta = $.map(product.meta, function(m) {
				other -= parseInt(m.value);
				single.find('.product_data').append('<div><strong class="pull-right">' + m.value + '%</strong>'+data.product_meta_types[m.meta_id]+'</div>');
				return {value: m.value,
				        color: pieChartColors[m.meta_id].normal,
				        highlight: pieChartColors[m.meta_id].hightlight,
				        label: data.product_meta_types[m.meta_id] + ': ' + m.value + '%'};
			});
			if(other > 0) {
				if(other == 100)
					single.find('.product_data').append('<div><strong class="pull-right">N/A</strong>'+data.year+' Data Not Set</div>');
				else
					single.find('.product_data').append('<div><strong class="pull-right">' + other + '%</strong>Other</div>');
				meta.push({value: other,
				        color: pieChartColors[0].normal,
				        highlight: pieChartColors[0].hightlight,
				        label: other == 100 ? 'Data Not Set' : 'Other: ' + other + '%'});
			}

			heights.push(single.outerHeight(true));
			var ctx = document.getElementById('product-chart-' + product.id).getContext("2d");
			var myPieChart = new Chart(ctx).Pie(meta,{
				animateRotate : false,
				segmentShowStroke: (other != 100),
				animationSteps: 1,
			} );
		});
		$('#mill-products .mill-products__single').css('height', _.max(heights));

		$('.donut-chart').each(function(){
			var c = $(this),
				percent = c.data('percent'),
				avg = c.data('avg'),
				dataset = { metric: [ percent, (100-percent) ] };

			var width = c.width(), height = c.width(), radius = Math.min(width, height) / 2;

			var color = t.colors.good;
			if(c.hasClass('secondary')) {
				color = '#ccc';
				c.closest('.chart-simple-donut').addClass('secondary');
			}
			// if(percent < avg+10 && percent > avg) {
			// 	color = t.colors.warning;
			// 	c.closest('.chart-simple-donut').addClass('warning');
			// } else if(percent > avg+10) {
			// 	color = t.colors.alert;
			// 	c.closest('.chart-simple-donut').addClass('alert');
			// }
			var colors = [color,'#eee'];

			var pie = d3.layout.pie().sort(null),
				arc = d3.svg.arc().innerRadius(radius-20).outerRadius(radius-40);

			var svg = d3.select("#"+c.attr('id')).append("svg")
			    .attr("width", width)
			    .attr("height", height)
			    .append("g")
			    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

			var path = svg.selectAll("path")
			    .data(pie(dataset.metric))
			  	.enter().append("path")
			    .attr("fill", function(d, i) {
			    	return colors[i];
			    })
			    .attr("d", arc);
		});
	},
	toggleAdditionalFilters: function(){
		if(!$('#toggle-search-filters').hasClass('active')) {
			$('#toggle-search-filters').addClass('active').text('Hide Filters');
			$('#additional-search-filters').slideDown();
		} else {
			$('#toggle-search-filters').removeClass('active').text('More Filters');
			$('#additional-search-filters').slideUp();
		}
	},
	requestSupplier: function(e){
		var t = this,
			el = $(e.target),
			mill_id = el.data('mill'),
			name = $('#supplier-mill-' + mill_id).find('.mill__name').text(),
			business = el.closest('.buyer-supplier-search__item').find('.supplier-business-information h4.business-name').text(),
			location = $('#supplier-mill-' + mill_id).find('.mill__location').text();
		e.preventDefault();

		$('#mill-request-message').val('');
		$('#request-access-modal span.business-name-span').text(business);
		$('#mill-request-fields').html('').append('<li data-mill="'+mill_id+'">'+name+'</li>');
		$('#request-access-modal').foundation('reveal', 'open');
	},
	requestSupplierSubmit: function(){
		var mills = [], msg = $('#mill-request-message').val();
		$('#mill-request-fields li').each(function(){
			mills.push($(this).data('mill'));
		});
		$.post('/buyer/suppliers/request', {mills: mills, msg: msg, _token: $('#send-supplier-request').data('token')}, function(rsp){
			$.each(mills, function(index, mill) {
				$('#supplier-mill-' + mill).find('.mill__request-status').html('<span class="requested-supplier">Requested</span>');
			});
			$('#request-access-modal').foundation('reveal', 'close');
		});
	},
	approveBuyer: function(e){
		var t = this, el = $(e.target);
		e.preventDefault();
		$.get('/supplier/buyers/approve/' + el.data('id'), function(){
			el.removeClass('approve-buyer').text('Access Approved!');
			el.closest('li').find('.reject-buyer').remove();
			el.closest('li').delay(1500).slideUp();
		});
	},
	rejectBuyer: function(e){
		var t = this, el = $(e.target);
		e.preventDefault();
		$.get('/supplier/buyers/reject/' + el.data('id'), function(){
			el.removeClass('reject-buyer').text('Access Rejected');
			el.closest('li').find('.approve-buyer').remove();
			el.closest('li').delay(1500).slideUp();
		});
	},
	/* BUYER WEIGHT SETS */
	handleWeightsetSliderChange: function() {
		var pointsAvailable = 100;
		$('.wtset_slider').each(function(){
			pointsAvailable = pointsAvailable - parseInt($(this).attr('data-slider'));
		});
	},
	setWeightsetFinalized: function(e) {
		e.preventDefault();
		$('#wtset-finalized').val(1);
		$('#wtset-form').submit();
	},
	/* MILL DATA */
	lookupMilldata: function(){
		if($('#milldata-index-select').val() != '') {
			$('#create-milldata-btn').prop('disabled',false);
			$.get('/supplier/mill/' + $('#milldata-index-select').val() + '.json',function(data) {
				data.milldata = $.map( data.milldata, function( milldata ) {
					milldata.mill = data.mill.name;
					milldata.mill_id = data.mill.id;
					return milldata;
				});
				var template = Handlebars.compile($("#milldata-index-items").html());
				$('#milldata-index-list').html(template(data));
			});
		} else {
			$('#create-milldata-btn').prop('disabled',true);
			$('#milldata-index-list').html('');
		}
	},
	deleteMillData: function(e){
		e.preventDefault();
		var that = $(this);
		$.ajax({
			method: "DELETE",
			url: '/supplier/milldata/' + that.data('mill') + '/' + that.data('year'),
			data: {_token: that.data('token'), method: '_delete'},
			success: function() {
				that.closest('li.milldata-row').remove();
			}
		});
	},
	setupProductAssignment: function(){
		if($(this).val() == '') {
			$('#change-mill-products').hide();
		} else {
			$.get('/supplier/mill/' + $(this).val(), function(mill) {
				$('#change-mill-products').show();
				$('#assigning-products-list input[type="checkbox"]').prop('checked',false);
				$('#update-mill-products').text('Save Changes to ' + mill.mill.name);
				$.each(mill.products_latest, function(index, product) {
					$('#product-' + product.id).prop('checked',true);
				});
			});
		}
	},
	updateProductAssignment: function(e) {
		e.preventDefault();
		var that = $(this), mill = $('#mill-products-select').val(), products = [];
		$('#assigning-products-list input[type="checkbox"]').each(function() {
			if($(this).prop('checked')) {
				products.push($(this).val());
			}
		});
		$('#change-mill-products .alert-box').remove();
		$.post('/supplier/product/mill/' + mill, {products: products, _token: that.data('token')}, function(response) {
			if(response != null) {
				$('#change-mill-products').prepend('<div class="alert-box radius">Mill "'+response.name+'" has been updated.</div>');
				$('#change-mill-products .alert-box').delay(3000).slideUp();
			}
		});
	},
	getBuyerPermissions: function(){
		if($(this).val() == '') {
			$('#change-mill-products').hide();
		} else {
			$('#change-mill-products').show();
			$('input.mill-business-permit').prop('checked',false);
			$.get('/supplier/buyers/' + $(this).val(), function(buyer) {
				$.each(buyer.permitted, function(index, permit) {
					$('#mill-business-permit'+permit.mill_id).prop('checked',true);
				});
			});
		}
	},
	updateBuyerPermissions: function(e){
		var permissions = [], that = $(this);
		$('.mill-business-permit:checked').each(function(){
			permissions.push({ mill_id: $(this).val() });
		});
		$.post('/supplier/product/permit/' + $('#permit-business-select').val(), {permissions: permissions, _token: that.data('token')}, function(buyer) {
			$('#change-mill-products').prepend('<div class="alert-box radius">Mill "'+buyer.name+'" has been updated.</div>');
			$('#change-mill-products .alert-box').delay(3000).slideUp();
		});
	},
	initCorrectMetricRange: function() {
		$('.metric_sub_radio:checked').each(function() {
			var that = $(this), selected = that.val(), metric = that.data('metric');
			$('#' + metric + selected).show();
		})
	},
	showCorrectMetricRange: function(){
		var that = $(this), selected = that.val(), metric = that.data('metric');
		$('.' + metric).hide();
		$('#' + metric + selected).show();
	},
	updateSliderDisplay: function(){
		var t = $(this);
		t.find('.slider-value-display span').text(t.attr('data-slider'));
	},
	deleteUser: function(e) {
		e.preventDefault();
		var that = $(e.target), a = that.attr('href');
		$.ajax({
			url: a,
			data: {_token: $('#user-form input[name="_token"]').val(), method: '_delete'},
			method: 'DELETE',
			success: function(){
				window.location = "/user";
			}
		});
	},
	initProductMetaForm: function(){
		var t = this;
		$('.product-meta-slider').each(function(){
			var s = $(this), val = s.data('value');
			s.slider({
				min: 0,
				max: 100,
				value: val,
				create: function( event, ui ) {
					s.find('.ui-slider-handle').html('<span class="handle-value">'+val+'%</span>');
				},
				slide: t.handleProductMetaSlider,
				stop: t.handleProductMetaSlider
			});
		});
		var val = 0;
		$('.product-meta-slider').each(function(){
			val += $(this).slider('value');
		});
		// val = 100 - val;
		$('#product-meta-other').text(val + '%');
		$('#submit-product-meta-form').prop('disabled',(val < 0));
	},
	handleProductMetaSlider: function(event, ui){
		var t = this;
		$(this).closest('.slider-container').find('.slider-value').val(ui.value);
		$(this).find('.handle-value').text(ui.value+'%');
		var val = 0;
		$('.product-meta-slider').each(function(){
			val += $(this).slider('value');
		});
		// val = 100 - val;
		$('#product-meta-other').text(val + '%');
		$('#submit-product-meta-form').prop('disabled',(val < 0));
	},
	initMillMetaSliders: function() {
		var t = this;
		$('.mill-meta-slider').each(function(){
			var s = $(this),
				val = s.data('value'),
				min = s.data('min'),
				max = s.data('max');
			s.slider({
				min: min,
				max: max,
				value: val,
				create: function( event, ui ) {
					s.find('.ui-slider-handle').html('<span class="handle-value">'+val+'</span>');
				},
				slide: t.handleMillMetaSlider,
				stop: t.handleMillMetaSlider
			});
		});
	},
	handleMillMetaSlider: function(event, ui) {
		var t = this;
		$(this).closest('.slider-container').find('.slider-value').val(ui.value);
		$(this).find('.handle-value').text(ui.value);

		if($(t).closest('li').data('sum-group') !== undefined) {
			EPAT.handleSumGroupTotal($(t).closest('li').data('sum-group'));
			// var sg = $(t).closest('li').data('sum-group');
			// $('li[data-sum-group="'+sg+'"]').

			// console.log('has sum group...');
		}

	},
	handleAjaxDelete: function(e){
		e.preventDefault();
		var t = this, el = $(e.target), url = el.attr('href'), token = el.data('token'), parent_item = el.data('closest');
		if(confirm("Are you sure you want to delete this? It can not be undone.")){
			$.ajax({
				method: "DELETE",
				url: url,
				data: {_token: token, method: '_delete'},
				success: function() {
					el.closest(parent_item).remove();
				}
			});
		}
	},
	productMetaModal: function(e) {
		e.preventDefault();
		var t = this, el = $(e.target), url = el.attr('href');
		$('#product-year-data').foundation('reveal', 'open', {
		    url: url,
		    success: function(data) {
		    	setTimeout(function(){
	    			t.initProductMetaForm();
	    		},500);
		    }
		});
	},
	productMetaFormSubmit: function(){
		var data = $('#product-meta-form').serialize(),
			url = $('#product-meta-form').attr('action'),
			method = $('#product-meta-form').attr('method');

		if($('#product-meta-form select[name="year"]').val() == '') {
			alert('Please select a year');
			return;
		} else {
			$.ajax({
				method: method,
				url: url,
				data: data,
				success: function(data) {
					var years_template = Handlebars.compile($('#product-data-years-template').html());
					$('#product-data-years').html(years_template(data));
					$('#product-year-data').foundation('reveal', 'close');
				}
			});
		}
	},
	setupMillAuthSelect2: function() {
		var mill_template = Handlebars.compile($('#mill-authorization-item-template').html());

		mill_auth_items = $.map(mill_auth_items, function(i) {
			i.text = i.name;
			i.id = parseInt(i.id);
			return i;
		});
		$("#mill-add-authorization").select2({
			placeholder: "Search For A Business",
			data: mill_auth_items
		});
		$("#mill-add-authorization").on("select2:select", function (e) {
			var id = $("#mill-add-authorization").val();
			$.each(id, function(index, mill_id) {
				if($('#mill-authorization-item-' + mill_id).length == 0){
					var m = _.findWhere(mill_auth_items, {id: parseInt(mill_id)});
					$('#mill-add-authorization-list').append(mill_template(m));
				}
			});
			$("#mill-add-authorization").select2('val',[]);
		});

		$('body').on('click','.remove-mill-auth-item',function(e) {
			e.preventDefault();
			$(this).closest('.mill-authorization-item').remove();
		});
	},
	handleMillFileAjax: function() {

		// $('#mill-file-upload__file').fileupload({
	 //        url: '/supplier/file/' + $('#mill-file-upload__file').data('mill'),
	 //        dataType: 'json',
	 //        done: function (e, data) {
	 //        	console.log(data.result.files);
	 //        	$('#mill-file-uploader-progress').hide();
	 //        },
	 //        progressall: function (e, data) {
	 //            var progress = parseInt(data.loaded / data.total * 100, 10);
	 //        	$('#mill-file-uploader-progress').show();
	 //            $('#mill-file-uploader-progress .meter').css( 'width', progress + '%' );
	 //        }
	 //    });

	 // console.log( $('#mill-file-upload__add').data('mill'));

		var that = this;

		var uploader = new plupload.Uploader({
		    runtimes : 'html5,flash,silverlight,html4',

		    browse_button : 'mill-file-upload__add', // you can pass in id...

		    url : '/supplier/file/' + $('#mill-file-upload__add').data('mill'),

		    filters : {
		        max_file_size : '500mb',
		        // mime_types: [
		        //     {title : "Image files", extensions : "jpg,gif,png"},
		        //     {title : "Zip files", extensions : "zip"}
		        // ]
		    },

		    multipart_params: {
		    	'_token': $('#mill-file-upload__add').data('csrf')
		    },

		    flash_swf_url : '../bower_components/plupload/js/Moxie.swf',
		    silverlight_xap_url : '../bower_components/plupload/js/Moxie.xap',

		    init: {
		        FilesAdded: function(up, files) {
		            uploader.start();
		            $('#mill-file-uploader-progress').show();
		            $('#mill-file-upload__add').hide();
		        },
		        UploadProgress: function(up, file) {
		        	$('#mill-file-uploader-progress .meter').css( 'width', file.percent + '%' );
		        },
		        FileUploaded: function(up, file, rsp){
		        	rsp = $.parseJSON(rsp.response);
		        	var output = '<li><a class="panel" href="/download/'+rsp.id+'"><span class="fi-cloud-transfer-download"></span> ' + rsp.name + '</a>'+
		        		'<a href="/supplier/file/delete/'+rsp.id+'" data-closest="li" data-token="'+$('#mill-file-upload__add').data('csrf')+'" class="fi-circle-x delete-mill-file"></a></li>';
		        	$('#millfiles-list').append(output);
		        	uploader.removeFile(file);

		        	$('#no-mill-files').hide();

		            $('.delete-mill-file').unbind('click').on('click', $.proxy( that.handleAjaxDelete, that));
		        },
		        UploadComplete: function() {
		            $('#mill-file-uploader-progress').hide();
		            $('#mill-file-upload__add').show();
		        },
		        Error: function(up, err) {
		        	uploader.removeFile(up.files[0]);
		            $('#mill-file-uploader-progress').hide();
		            $('#mill-file-upload__add').show();
		        	alert("Error #" + err.code + ": " + err.message);
		        }
		    }
		});
		uploader.init();

	},
	handleMillDataForm: function(){
		var that = this;

		that.handleMillDataBoolean();
		$('.mill-data-boolean input[type="checkbox"]').on('click', that.handleMillDataBoolean);

		var sumGroups = _.map($('#milldata-form li.form-indicator-lists__item'), function(i){ return $(i).data('sum-group'); });
		sumGroups = _.uniq(_.filter(sumGroups, function(g){ return g !== undefined; }));

		_.map(sumGroups, function(g){
			$('#milldata-form li.form-indicator-lists__item[data-sum-group="'+g+'"]').first().before('<li class="sum-group-li" data-group="'+g+'" id="sum-group-total__'+g+'">'+that.sumGroups[g].title+': <span class="sum">0</span>'+(that.sumGroups[g].percent ? '%' : '')+' / '+that.sumGroups[g].max+(that.sumGroups[g].percent ? '%' : '')+' Max</li>');
			that.handleSumGroupTotal(g);
		});

		$('#milldata-form').on('submit', function(e){
			if($('.max-value-exceeded').length > 0) {
				e.preventDefault();
				alert('You have exceeded the maximum allowed value.');

				var sumGroup = $('.max-value-exceeded').first().data('group');
				$('body, html').animate({scrollTop: $('#milldata-form li.form-indicator-lists__item[data-sum-group="'+sumGroup+'"]').first().offset().top },'fast');
				return false;
			}
		});

	},
	handleMillDataBoolean: function() {
		$('.mill-data-boolean input[type="checkbox"]').each(function(){
			var t = $(this), inputField = t.closest('.mill-data-boolean').find('input[type="text"]');
			if(t.prop('checked')) {
				inputField.removeAttr('disabled');
			} else {
				inputField.attr('disabled','disabled');
			}
		});
	},
	handleSumGroupTotal: function(sumGroup) {
		var that = this;

		var values = _.map($('.form-indicator-lists__item[data-sum-group="'+sumGroup+'"] input[name$="[meta_value]"]'),function(i){
			return parseInt('0' + $(i).val());
		}).reduce(function add(a, b) {
			return a + b;
		},0);

		if(values > that.sumGroups[sumGroup].max) {
			$('#sum-group-total__' + sumGroup).addClass('max-value-exceeded');
		} else {
			$('#sum-group-total__' + sumGroup).removeClass('max-value-exceeded');
		}
		$('#sum-group-total__' + sumGroup + ' .sum').text(values);
	}

};

jQuery( document ).ready(function( $ ) {
	EPAT.init();
});

